/** The connector's address and setup snippets for common MCP clients (spec §8.27). */
export function connectorUrl(origin: string = window.location.origin): string {
  return `${origin}/mcp`;
}

/** Claude Code: `claude mcp add --transport http <name> <url> --header "…"` (verified with `claude mcp add --help`). */
export function claudeCodeCommand(token: string, origin?: string): string {
  return `claude mcp add --transport http kss ${connectorUrl(origin)} --header "Authorization: Bearer ${token}"`;
}

/** The `mcpServers` JSON that Claude Code's `.mcp.json` and many other clients read. */
export function jsonConfig(token: string, origin?: string): string {
  return JSON.stringify({ mcpServers: { kss: { type: "http", url: connectorUrl(origin), headers: { Authorization: `Bearer ${token}` } } } }, null, 2);
}
